/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_like.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns `true` when any value yielded by `field` matches `pattern`, using the same wildcard syntax as `LIKE`.\n`LIKE` is a single-value scalar: applied to a multivalue field it emits a warning and returns `null`, so this\nis how you match a wildcard pattern against a multivalue field. A null or empty `field` returns `false`, and\nbecause the result is never null the predicate composes under `AND`/`OR`/`NOT`.',
  examples: [
    'ROW names = ["Anna", "Bob", "Carl"]\n| EVAL any_starts_with_a = mv_like(names, "A*")',
    'ROW names = ["Anna", "Bob"]\n| EVAL has_bo = mv_like(names, "Bo*")',
    'ROW names = ["Anna", "Bob"]\n| EVAL no_carl = NOT mv_like(names, "Carl*")',
  ],
  params: {
    field: 'Multivalue expression to test. If null or empty, the function returns `false`.',
    pattern: 'Wildcard pattern. Must be a constant. `*` matches any run of characters, `?` matches a single character; escape either with `\\`.',
  },
};

export default docs;
